import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { SettingService } from './setting.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {

  constructor(private http: HttpClient, private settingsService: SettingService) { }

  url = this.settingsService.settings.usuario;
  error: any;
  user = { dni: '' }
  cuser = { nombre: '', apePaterno: '', apeMaterno: '' };


  private dni = new BehaviorSubject(this.user);
  currentDni = this.dni.asObservable();

  addCards(dni) {
    this.user = { dni: dni };
    this.dni.next(this.user)
  }
  private userApp = new BehaviorSubject(this.cuser)
  currentUser = this.userApp.asObservable();

  addCurrentUser(nombre: string, apePaterno: string, apeMaterno: string) {
    this.cuser = { nombre: nombre, apePaterno: apePaterno, apeMaterno: apeMaterno };
    this.userApp.next(this.cuser)
  }
  addUser(json) {
    return this.http.post(this.url + '/usuario/nuevo', JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }
  loadUser(json) {
    return this.http.post(this.url + '/usuario/cargaPerfil', JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }
  updateUser(json) {
    return this.http.post(this.url + '/usuario/actualizaPerfil', JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }
}